<template>
  <div class="instrucciones">

    <h1 class="mb-4">Instrucciones</h1>

    <h2 class="ma-4">Leyes sobre el cómputo de honorarios y aranceles</h2>

    <v-row justify="center" class="ma-md-8">
      <v-expansion-panels popout focusable>
        <v-expansion-panel
          class="my-1"
        >
          <v-expansion-panel-header color="primary" class="text-subtitle-1">Aranceles escrituras</v-expansion-panel-header>
          <v-expansion-panel-content class="ma-4">
            A continuación presentamos los fragmentos más importantes de la ley. Presione el siguiente botón para ir al enlace de la Ley Núm. 101.
            <br>
            <v-btn class="my-8" color="primary" href="https://bvirtualogp.pr.gov/ogp/Bvirtual/leyesreferencia/PDF/101-1943.pdf" target="_blank">Ver Ley Núm. 101</v-btn>

            <p class="text-h6">Rentas Internas</p>
            Ley para Regular el Cobro de Derechos sobre Documentos e Instrumentos Públicos y Privados Protocolizados ante Notario Público en Puerto Rico
            (Ley Núm. 101 de 12 de mayo de 1943, según enmendada)
            <br>
            <br>
            Sección 2. — (4 L.P.R.A. § 851)
            <br>
            <br>
            (1) En cada documento e instrumento original, autorizado por notario público, que haya de ser
            protocolizado, y sus copias, se fijarán y cancelarán sellos de rentas internas de los siguientes
            valores o denominaciones:
            <br>
            <br>
            (a) Cuando dicho documento sea por una cuantía que no exceda de doscientos cincuenta
            dólares ($250), cincuenta centavos (50¢) por el original y veinte centavos (20¢) por cada copia.
            <br>
            <br>
            (b) Cuando la cuantía exceda de doscientos cincuenta dólares ($250) y no pase de quinientos
            dólares ($500), un dólar ($1) por el original y cincuenta centavos (50¢) por cada copia.
            <br>
            <br>
            (c) Cuando la cuantía exceda de quinientos dólares ($500) y no pase de mil dólares ($1,000),
            dos dólares ($2) por el original y un dólar ($1) por cada copia.
            <br>
            <br>
            (d) Cuando la cuantía exceda de mil dólares ($1,000) y no pase de cinco mil dólares ($5,000),
            dos dólares ($2) por los primeros mil dólares ($1,000) y cincuenta centavos (50¢) adicionales
            por cada mil dólares ($1,000) o fracción de mil dólares por el original; y un dólar ($1) por los
            primeros mil dólares y veinte centavos (20¢) adicionales por cada mil dólares o fracción de
            mil dólares por cada copia.
            <br>
            <br>
            (e) Cuando la cuantía exceda de cinco mil dólares ($5,000), dos dólares ($2) por los primeros
            mil dólares ($1,000) y un dólar ($1) adicional por cada mil dólares ($1,000) o fracción de mil
            dólares por el original; y un dólar ($1) por los primeros mil dólares ($1,000) y cincuenta
            centavos (50¢) adicionales por cada mil dólares ($1,000) o fracción de mil dólares ($1,000)
            por cada copia.
            <br>
            <br>
            <p class="text-h6">Asistencia Legal</p>
            (2)Además del cobro de derechos que se establece en el inciso (1), en cada documento de escritura
            de compraventa; compraventa e hipoteca, venta judicial, constitución o cancelación de hipoteca
            que haya de ser protocolizado y por cada copia de éstas, se fijarán y cancelarán sellos, que la
            Sociedad para Asistencia Legal adoptará y expedirá, por valor de cinco (5) dólares en el original
            y dos dólares con cincuenta (2.50) centavos en toda copia, cuando la cuantía del documento sea
            entre veinticinco mil (25,000) y cincuenta mil (50,000) dólares. Cuando la cuantía del documento
            exceda de cincuenta mil (50,000) dólares se fijarán y cancelarán sellos adicionales, de cinco (5)
            dólares en el original y dos dólares con cincuenta (2.50) centavos en toda copia, por cada cincuenta
            mil (50,000) dólares o fracción subsiguiente. No existirá la obligación de cancelar los sellos a favor
            de la Sociedad para Asistencia Legal aquí establecidos en aquellos casos en que la cuantía sea
            menor de veinticinco mil (25,000) dólares, ni cuando por disposición de ley se exima el cancelar
            sellos de Rentas Internas y el arancel notarial. 
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel
          class="my-1"
        >
          <v-expansion-panel-header color="primary" class="text-subtitle-1">Honorarios notariales</v-expansion-panel-header>
          <v-expansion-panel-content class="ma-4">
            A continuación presentamos los fragmentos más importantes de la Ley Notarial de Puerto Rico en lo referente a honorarios notariales.
            Presione el siguiente botón para ir al enlace de la Ley Notarial.
            <br>
            <v-btn class="my-8" color="primary" href="https://bvirtualogp.pr.gov/ogp/Bvirtual/leyesreferencia/PDF/75-1987.pdf" target="_blank">Ver Ley Notarial</v-btn>

            <p class="text-h6">Honorarios Notariales</p>
            Ley Notarial de Puerto Rico
            (Ley Núm. 75 de 2 de julio de 1987, según enmendada)
            <br>
            <br>
            Artículo 77. — (4 L.P.R.A. § 2127)
            <br>
            <br>
            Los notarios quedan autorizados a cobrar los siguientes honorarios por la prestación de
            servicios notariales, fijados de acuerdo al arancel establecido en las siguientes normas:
            <br>
            <br>
            (1) Documentos sin cuantía.
            
            (a) Por la autorización de instrumentos públicos sin cuantía, los honorarios notariales se fijarán
            por acuerdo entre las partes y el notario, pero nunca serán menores de ciento cincuenta dólares
            ($150).
            <br>
            <br>
            (b) Por la autorización de testimonios, declaraciones juradas y reconocimiento de firmas o
            affidávit, los honorarios notariales se fijarán por acuerdo entre las partes y el notario
            <br>
            <br>
            (2) Documentos con cuantía.
            <br>
            <br>
            Por la autorización de instrumentos con cuantía se percibirán los honorarios notariales que
            resulten aplicando el valor de los bienes objeto del negocio jurídico documentado, o que medie
            cosa o cantidad de valor determinable, conforme a la siguiente escala:
            <br>
            <br>
            (a) Por la autorización de instrumentos de objetos valuables o en que medie cosa o cantidad
            de valor determinable, cuyo valor no exceda de diez mil dólares ($10,000), los honorarios
            notariales fijados por este arancel serán de ciento cincuenta dólares ($150).
            <br>
            <br>
            (b) Por la autorización de instrumentos de objetos valuables o en que medie cosa o cantidad
            de valor determinable cuyo valor exceda de diez mil dólares ($10,000), pero que no exceda
            de cinco millones de dólares ($5,000,000), los honorarios notariales fijados por este arancel
            serán establecidos por acuerdo entre las partes y el notario, pero nunca será mayor del uno
            por ciento (1%) ni menor del punto cincuenta por ciento (.50%) de su valor, lo cual nunca
            será menor de doscientos cincuenta dólares ($250).
            <br>
            <br>
            (c) Por la autorización de instrumentos de objetos valuables o en que medie cosa o cantidad
            de valor determinable que exceda de cinco millones de dólares ($5,000,000), los honorarios
            notariales fijados por este arancel serán el arancel establecido en el inciso (b) anterior hasta
            dicha suma, más los honorarios notariales que sean establecidos por acuerdo entre las partes
            y el (la) notario(a) por el exceso de cinco millones de dólares ($5,000,000).
            <br>
            <br>
            (d) Por las cancelaciones de hipoteca, los honorarios notariales serán establecidos por
            acuerdo entre las partes y el (la) notario(a), los cuales nunca serán menores del punto
            cincuenta por ciento (0.50%) de la cuantía establecida como el principal del pagaré
            garantizado por la hipoteca a cancelarse, cuyo valor no exceda de cinco millones de dólares
            ($5,000,000). Cuando exceda los cinco millones de dólares ($5,000,000), los honorarios
            notariales se establecerán por acuerdo entre las partes y el notario. En ningún caso de los
            incluidos en este inciso la cuantía a pagar por honorarios notariales será menor de
            doscientos cincuenta dólares ($250).
            <br>
            <br>
            (e) En los casos de vivienda de nueva construcción y en los de refinanciamiento donde una
            parte otorgue en una misma transacción más de un instrumento público ante el mismo
            notario, se autoriza a este último a cobrar por los honorarios notariales del instrumento de
            mayor valor, lo establecido en los anteriores incisos (b) y (c), por los demás instrumentos
            de esa misma transacción, cobrará la mitad de lo dispuesto en los incisos anteriores;
            Disponiéndose, que la suma de lo cobrado nunca será mayor del uno por ciento (1%) del
            instrumento público de mayor valor.
            <br>
            <br>
            (3) Excepciones.
            <br>
            <br>
            (a) En los casos de viviendas de interés social los instrumentos públicos que se otorguen y
            en los que intervenga la Autoridad para el Financiamiento de la Vivienda de Puerto Rico,
            el Banco de Desarrollo Económico de Puerto Rico, el Banco Gubernamental de Fomento
            de Puerto Rico y cualquier otra agencia o instrumentalidad del Gobierno, sea estatal,
            municipal o federal, de manera directa o por medio de programas de subsidios, el arancel
            será fijado mediante acuerdo entre la parte y el notario, pero nunca será menor del punto
            veinticinco por ciento (0.25%) o doscientos cincuenta dólares ($250), lo que sea mayor,
            salvo que la ley habilitadora o reglamento que establezca el programa gubernamental
            disponga otra cosa. Cuando haya dos (2) o más instrumentos públicos otorgados sobre el
            valor total de una misma vivienda de interés social en una misma transacción, se dispone
            que los honorarios notariales nunca serán mayor del uno por ciento (1%) de la cantidad de
            valor determinable a la vivienda de interés social en cuestión. Esta cláusula se refiere a
            financiamientos de vivienda de interés social exclusivamente y no aplica a préstamos con
            financiamiento o refinanciamiento garantizado por agencias federales o estatales como por
            ejemplo, los conocidos como FHA, reverse, veteranos, y otros de la misma naturaleza.
            <br>
            <br>
            4) Normas complementarias
            <br>
            <br>
            (a) Ningún notario(a) podrá cobrar o recibir por sus servicios notariales otra compensación
            que no sea la establecida en este capítulo, ya sea mediante reembolso de los honorarios,
            concesión de descuentos o privilegios, o cualquier otro método utilizado para reducir los
            honorarios aquí establecidos. Esta prohibición no incluye la prestación de los servicios de
            forma gratuita cuando el notario lo entienda y considere meritorio, siempre y cuando no se
            haga como parte de una práctica habitual de negocios, ni como subterfugio, violentando así
            el propósito de este capítulo; de así hacerlo será sancionado según se establece en la
            cláusula (c) de este inciso. El notario informará en el índice mensual de actividad notarial,
            aquellos instrumentos públicos en los cuales prestó sus servicios de forma gratuita haciendo
            una marca en una columna que se incluya a esos efectos.
            <br>
            <br>
            (b) Cuando el notario sea empleado por un bufete, sociedad, o corporación de servicios
            profesionales, que preste servicios notariales, la obligación y la responsabilidad
            establecidas en la cláusula (a) de este inciso recaerán sobre el patrono que emplea al notario
            al momento de prestarse los servicios notariales.
            <br>
            <br>
            (c) Cualquier notario que incumpla las normas establecidas por el arancel fijado en este
            capítulo o comparta los honorarios notariales aquí fijados con personas naturales o jurídicas
            que no estén en cumplimiento con lo establecido en este capítulo, será sancionado por el
            Tribunal Supremo de Puerto Rico mediante reprimenda, multa, suspensión temporal o
            permanente.
            <br>
            <br>
            (d) Cualquier persona natural o jurídica, no integrada por notarios, que no estuviesen
            autorizadas a ejercer como notario según dispuesto por la Ley Notarial de Puerto Rico, que
            facture, perciba, reciba o comparta honorarios por servicios notariales con un notario o así
            lo inste, será culpable de delito grave en su modalidad de cuarto grado, y convicta que fuere
            se le impondrá una pena fija de reclusión de un (1) año, más una multa de cinco mil dólares
            ($5,000). En caso que la convicción recaiga sobre una persona jurídica, se procederá a la
            cancelación de su Certificado de Incorporación por el Departamento de Estado de Puerto
            Rico.
            <br>
            <br>
            Artículo 78. — (4 L.P.R.A. § 2132)
            <br>
            <br>
            Los honorarios anteriormente fijados por el otorgamiento de los documentos no impiden ni
            limitan al notario de que, por sus gestiones previas y preparatorias, e inclusive posteriores, tales
            como estudios de antecedentes, título, consultas, dictámenes, preparar minutas y mandatos
            retribuidos en que el notario presta un servicio adicional como jurista, cobre los honorarios que
            crea razonables y prudentes de acuerdo con el Canon 24 de Ética Profesional sobre la fijación de
            honorarios
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel
          class="my-1"
        >
          <v-expansion-panel-header color="primary" class="text-subtitle-1">Aranceles Registro</v-expansion-panel-header>
          <v-expansion-panel-content class="ma-4">
            A continuación presentamos los fragmentos más importantes de la Ley de Aranceles del Registro de la Propiedad.
            Presione el siguiente botón para ir al enlace de la Ley del Arancel de los Derechos que se han de Pagar por las Operaciones en el
            Registro de la Propiedad.
            <br>
            <v-btn class="my-8" color="primary" href="https://bvirtualogp.pr.gov/ogp/Bvirtual/leyesreferencia/PDF/Registro%20de%20la%20Propiedad/91-1970/91-1970.pdf" target="_blank">Ver Ley Aranceles Registro</v-btn>

            <p class="text-h6">Arancel por las Operaciones en el Registro de la Propiedad</p>
            Ley del Arancel de los Derechos que se han de Pagar por las Operaciones en el
            Registro de la Propiedad
            (Ley Núm. 91 de 30 de Agosto de 1970, según enmendada)
            <br>
            <br>
            Artículo 1. — (30 L.P.R.A § 1767a)
            <br>
            <br>
            ...
            <br>
            <br>
            Número Uno. — Por el asiento de presentación, respecto a cada documento cuya inscripción,
            anotación, cancelación o nota marginal de derecho se solicita, se pagará quince dólares ($15). De
            los derechos que se recauden por este concepto, doce dólares ($12) ingresarán en el Fondo Especial
            de Modernización y Mecanización del Registro de la Propiedad y tres dólares ($3) al Fondo
            General para los gastos de administración del mismo por parte del Secretario de Hacienda.
            <br>
            <br>
            Número Dos. — Por la inscripción, anotación, cancelación o liberación, de cada derecho en
            una finca, se pagarán los siguientes aranceles:
            <br>
            <br>
            (a) Si la finca o derecho vale mil dólares ($1,000) o menos, se pagarán dos dólares ($2).
            <br>
            <br>
            (b) Cuando el valor de la finca o derecho exceda de mil dólares ($1,000) se pagarán dos
            dólares ($2) por cada mil dólares ($1,000) o fracción de mil dólares ($1,000) del valor
            nominal de la finca hasta un valor máximo de veinticinco mil dólares ($25,000).
            <br>
            <br>
            (c) Cuando el valor de una finca o derecho exceda de veinticinco mil dólares ($25,000), se
            pagarán cincuenta dólares ($50) por los primeros veinticinco mil dólares ($25,000) y cuatro
            dólares ($4) por cada mil dólares ($1,000) o fracción de mil dólares ($1,000) adicionales.
            <br>
            <br>
            (d) Por las notas marginales que no envuelvan cuantía se pagarán cuatro dólares ($4) por
            cada una.
            <br>
            <br>
            (e) Por liberaciones gratuitas se pagarán cuatro dólares ($4) por cada liberación.
            <br>
            <br>
            (f) Por los derechos de la anotación de la reserva de prioridad de un contrato en gestación
            se pagará veinticinco dólares ($25).
            <br>
            <br>
            (g) Por los derechos de la inscripción del contrato de opción de compra se pagará
            veinticinco dólares ($25).
            <br>
            <br>
            (h) La anotación de embargo en ejecución de sentencia, así como su cancelación, pagará
            cuatro ($4) dólares.
            <br>
            <br>
            La anotación de demanda así como su cancelación pagará cuatro ($4) dólares.
            En todos los casos de anotación de sentencias, así como su cancelación, se pagará
            cuatro ($4) dólares.
            <br>
            <br>
            (i) Por los derechos de modificación de hipoteca se pagará:
            <br>
            <br>
            1. En los casos de ampliación, por el monto de la ampliación.
            <br>
            <br>
            2. En los casos de cancelación parcial, por la cantidad pagada parcialmente.
            <br>
            <br>
            3. En los casos de modificación sin cuantía, cuatro dólares ($4).
            <br>
            <br>
            4. Cuando la ampliación o cancelación conlleve alguna otra modificación, se cobrarán
            cuatro dólares ($4) adicionales.
            <br>
            <br>
            (j) Por la cancelación de una hipoteca se pagará:
            <br>
            <br>
            1. Por la hipoteca vigente, por el monto del principal.
            <br>
            <br>
            2. Por la hipoteca no vigente, cuatro dólares ($4).
            <br>
            <br>
            ...
            <br>
            <br>
            Artículo 2. — (30 L.P.R.A § 1767b)
            <br>
            <br>
            El arancel establecido en los números 1 al 4 anteriores regirá de acuerdo con las normas que
            siguen:
            <br>
            <br>
            Primera.— Cuando se haga una trasmisión de finca o derecho por donación, ya sea por
            renuncia de derecho o cualquier otro acto, incluyendo el derecho hereditario, se estimará como
            valor de la finca o derecho, el valor aceptado preliminarmente por el Secretario de Hacienda según
            conste en el certificado de cancelación de gravamen expedido por dicho funcionario.
            <br>
            <br>
            Segunda.— En los casos de transmisión de participaciones determinadas e inscritas en una
            comunidad de bienes, se pagará el arancel conforme al valor de la participación transmitida. Dicho
            valor se calculará tomando como base el valor real de la propiedad o el valor que surja del Registro,
            el que sea mayor.
            <br>
            <br>
            Tercera.— En todos los casos de usufructo, uso y habitación se tendrá que valorar el derecho
            y pagar por el valor que resulte.
            <br>
            <br>
            Cuarta.— En todos los casos de segregación se pagará por el valor de dicha segregación. En
            los casos de segregación y compraventa, cesión, enajenación, se pagará solamente por el valor de
            éstas, y no se pagará por la segregación.
            <br>
            <br>
            Quinta.— En todos los casos de agrupación se pagará por el valor de dicha agrupación. En los
            casos de agrupación y compraventa, cesión, enajenación o cualquier otro, se pagará solamente por
            el valor de éstas, y no se pagará por la agrupación.
            <br>
            <br>
            Sexta.— En todo caso de agregación se cobrarán los derechos por el valor que se le asigne a
            la finca o porción de la finca que se agrega. En los casos de segregación y agregación no será
            necesario valorar la segregación. En los casos de segregación, agregación y compraventa, se
            pagará solamente por el valor de la compraventa y no por el valor de la segregación y la agregación.
            <br>
            <br>
            Séptima.— En los arrendamientos servirá de base para fijar los derechos arancelarios la
            cantidad que ha de ser pagada por concepto de renta o canon durante el término del contrato hasta
            un máximo de quince (15) anualidades.
            <br>
            <br>
            Cuando el contrato no establezca plazo de duración, servirá de base el importe de quince (15)
            anualidades.
            <br>
            <br>
            Octava.— En todo caso de dación en pago, se pagarán derechos por el valor de dicha dación.
            <br>
            <br>
            Novena.— En todo caso de permutas se cobrará por la suma del valor de las fincas a
            permutarse. En el caso de permuta por bienes muebles, tales como, pero no limitados a, acciones
            o valores, se le dará valor a los mismos para propósitos del pago de aranceles.
            <br>
            <br>
            En los casos anteriores, los valores asignados deberán ser equivalentes.
            <br>
            <br>
            Décima.— Se cobrará la totalidad de los derechos cuando el asiento de inscripción, anotación,
            cancelación, liberación o nota marginal sea denegada y en su lugar se tome la correspondiente
            anotación. Si posteriormente procediera la inscripción denegada, se hará libre de pago de
            derechos.
            <br>
            <br>
            Undécima.— Si en el documento no se valoran los derechos respecto a inscripciones,
            anotaciones y cancelaciones de servidumbres se cobrará diez dólares ($10) por cada asiento.
            <br>
            <br>
            Duodécima.— En todo caso de transmisión de fincas hipotecadas se cobrará lo que sea mayor
            entre la suma total de las hipotecas o el valor de transmisión.
            <br>
            <br>
            Decimotercera. — En los casos de reconocimiento de titularidad, testaferro o mandato, se
            pagará por el valor de la propiedad.
            <br>
            <br>
            Decimocuarta. — En todo caso de fusión o consolidación de corporaciones se pagará la suma
            de cien dólares ($100). En casos de cambio de nombre, se pagarán cuatro dólares ($4.00).
            <br>
            <br>
            Decimoquinta. — En los casos de liquidación de sociedad de gananciales se cobrará por el
            valor total de la propiedad, excepto en aquellos casos donde las partes decidan adjudicarse
            participaciones concretas. En estos casos, se pagará por el valor de las participaciones. En los
            casos en que la propiedad esté gravada con hipotecas que sumen más que el valor de la propiedad
            o la transmisión se realice con posterioridad a la adjudicación, se pagará la cantidad que sea mayor.
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>

  </div>
</template>

<script>
  export default {
    data () {
      return {
      }

    }
  }
</script>

